<sdc-bo-dialog
  [headerTitle]="action === 'edit' ? 'Edit Adlink' : 'Preview Adlink'"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'adlink-edit-modal-' + item?.id">
  <div class="content-wrapper" [class.preview]="action === 'preview'">
    @if (action === 'edit') {
      <div>
        <div class="image-field">
          <span><b>Add new image</b></span>
          <small>(transparent png recommended)</small>
          @if (imagePreview || item.urlImage) {
            <div class="image-preview">
              <img [src]="imagePreview || item.urlImage" alt="" />
            </div>
          }
          @for (epoch of [fileUploadEpoch()]; track epoch) {
            <sdc-file-upload
              name="adlink-image"
              accept="image/*"
              placeholder="Upload image"
              (filesChange)="onFilesChange($event)" />
          }
          @if (item.urlImage || postImage) {
            <sdc-button
              variant="destructive"
              size="sm"
              (onClick)="removeImage()">
              Remove Image
            </sdc-button>
          }
        </div>
        <div class="content-wrapper">
          <div class="fields-column">
            <span><b>Name</b> <span class="mandatory-asterisk">*</span></span>
            <sdc-input
              name="adlink-name"
              [attr.data-cy]="'adlink-edit-modal-name-input'"
              [control]="nameControl"
              errorDisplayMode="always"
              errorMessage="The entry is mandatory" />
            <span><b>Title</b> <span class="mandatory-asterisk">*</span></span>
            <sdc-input
              name="adlink-title"
              [isTextarea]="true"
              [attr.data-cy]="'adlink-edit-modal-title-input'"
              [control]="titleControl"
              errorDisplayMode="always"
              errorMessage="The entry is mandatory" />
            <div class="link-field">
              <div class="link-field-label">
                <span
                  ><b>Link</b> <span class="mandatory-asterisk">*</span></span
                >
                @if (previewlink) {
                  <a [href]="previewlink" class="link-preview" target="_blank">
                    <ng-icon name="lucideLink" aria-hidden="true" />
                    <small>Preview</small>
                  </a>
                }
              </div>
              <div class="link-field-input">
                @if (!hideProtocol) {
                  <small class="link-protocol">https://</small>
                }
                <sdc-input
                  name="adlink-link"
                  [attr.data-cy]="'adlink-edit-modal-link-input'"
                  [control]="linkControl"
                  errorDisplayMode="always"
                  errorMessage="The entry is not valid" />
              </div>
            </div>
            <sdc-checkbox
              label="Visible"
              labelPosition="right"
              name="adlink-visible"
              [control]="activeControl" />
          </div>
          <div class="events-column">
            <gs-event-selector
              [mode]="'multiple'"
              [initialSelected]="item.events"
              [ngModel]="selectedEventIds"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="
                onEventSelectionChange($event)
              "></gs-event-selector>
          </div>
        </div>
      </div>
    }

    @if (action === 'preview') {
      <div id="html-preview">
        <div [innerHTML]="previewHtml"></div>
      </div>
    }
  </div>
  <ng-container sdc-bo-dialog-footer>
    @if (action === 'edit') {
      <sdc-button
        variant="secondary"
        [attr.data-cy]="'adlink-edit-modal-cancel-button'"
        (onClick)="onDismiss('cancel')">
        Cancel
      </sdc-button>
      <sdc-button variant="outline" (onClick)="openPreview()">
        <ng-icon name="lucideEye" aria-hidden="true" /> Preview
      </sdc-button>
      <sdc-button
        variant="primary"
        [attr.data-cy]="'adlink-edit-modal-confirm-button'"
        (onClick)="onConfirm()">
        Save & Publish
      </sdc-button>
    } @else {
      <sdc-button variant="secondary" (onClick)="closePreview()">
        <ng-icon name="lucideArrowLeft" aria-hidden="true" /> Back to Edit
      </sdc-button>
      <sdc-button variant="primary" (onClick)="onDismiss('cancel')">
        Close
      </sdc-button>
    }
  </ng-container>
</sdc-bo-dialog>
